import Vue from 'vue'

// HELP
import A3 from '@/views/help/A3'

Vue.component('A3', A3)

export default {}



// WEBPACK FOOTER //
// ./src/router/help.js